import React from 'react';
import { Col, Row } from 'reactstrap';

import Titled from '../layout/Titled';
import { brandShape } from '../prop-types';
import api from '../REST/api';
import AuthorizedLink from '../REST/AuthorizedLink';
import CampaignStatistics from '../statistics/ResolvedCampaignStatistics';
import BrandForm from './BrandForm';

const BrandInfo = ({ model }) => (
  <Titled
    title={model.name}
    actions={
      <AuthorizedLink
        to="edit"
        className="btn btn-secondary"
        query={api.patchBrand}
      >
        Edit
      </AuthorizedLink>
    }
    sticky
  >
    <Row>
      <Col sm="6">
        <Titled title="KPIs" size="tn">
          <CampaignStatistics brandId={model.id} />
        </Titled>
      </Col>
      <Col sm="6">
        <Titled title="Details" size="tn">
          <BrandForm model={model} />
        </Titled>
      </Col>
    </Row>
  </Titled>
);

BrandInfo.propTypes = {
  model: brandShape.isRequired,
};

export default BrandInfo;
